import { Button, Card, CardHeader } from "reactstrap";
import { Table, TableRow } from "../../../../components/Table";
import React, { useEffect, useState } from "react";
import { FILTER } from "../../../../constant";
import { useDispatch } from "react-redux";
import { responseToaster } from "../../../../helperFunctions";
import { useRole } from "../../../../redux/slices/authSlice";
import {
  getMerchantPermission,
  merchantRoleGet,
  useMerchantRole,
} from "../../../../redux/slices/merchantSlice";
import DeleteModal from "../../../../components/Custom/Modals/DeleteModal/DeleteModal";
import { rolesDelete } from "../../../../redux/slices/rolesSlice";
import AddRoleModal from "./AddRoleModal";

const SubUser = (props) => {
  const { merchantData } = props;
  const [filterColumns, setFilterColumns] = useState([]);
  const [filter, setFilter] = useState(FILTER);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isDeleteOpenModal, setIsDeleteOpenModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const role = useRole("Merchant");

  const data = useMerchantRole();
  const dispatch = useDispatch();

  const onDelete = async () => {
    try {
      setDeleteLoading(true);
      const payload = {
        id: isDeleteOpenModal?.id,
      };
      const res = await dispatch(rolesDelete(payload)).unwrap();
      responseToaster(res);
      setFilter({
        ...filter,
      });
      setIsDeleteOpenModal(null);
      setDeleteLoading(false);
    } catch (err) {
      setDeleteLoading(false);
    }
  };

  const columns = [
    {
      title: "Id",
      name: "id",
    },
    {
      title: "name",
      name: "name",
    },
    {
      title: "merchant id",
      name: "merchant_id",
    },
    {
      title: "guard name",
      name: "guard_name",
    },
    {
      title: "CREATED AT",
      name: "created_at_ist",
    },
    {
      title: "ACTIONS",
      name: "actions",
      Cell: (data) => {
        return (
          <>
            <div className="button-space d-flex">
              {role.includes("merchant-role-edit") ? (
                <Button
                  title="Edit"
                  color="primary"
                  className="btn-smallsize"
                  onClick={() => {
                    setIsOpenModal(data);
                  }}
                >
                  Edit
                </Button>
              ) : null}
              {role.includes("merchant-role-delete") ? (
                <Button
                  title="Delete"
                  className="btn-smallsize"
                  color="danger"
                  onClick={() => setIsDeleteOpenModal(data)}
                >
                  Delete
                </Button>
              ) : null}
            </div>
          </>
        );
      },
    },
  ];
  const onGetData = async () => {
    try {
      setIsLoading(true);
      const { isFilter, ...payload } = filter;
      const clonedPayload = {
        merchantId: merchantData?.merchantId,
        ...payload
      }
      const res = await dispatch(merchantRoleGet(clonedPayload)).unwrap();
      if (isFilter) {
        responseToaster(res);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (role.includes("merchant-role-list") && merchantData?.merchantId) {
      onGetData();
    }
  }, [filter, merchantData]);

  const onGetMerchantPermission = async () => {
    try {
      await dispatch(getMerchantPermission({ merchantId: merchantData?.merchantId })).unwrap()
    } catch (error) {
    }
  }
  useEffect(() => {
    if (merchantData?.merchantId) {
      onGetMerchantPermission()
    }
  }, [merchantData?.merchantId])

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  if (!role.includes("merchant-role-list")) {
    return
  }

  return (
    <>
      <div className="merchant-main-div">
        <Card>
          <CardHeader className="flex-column align-items-start">
            <div className="d-flex align-items-center w-100 justify-content-between">
              <h4 className="main-title">
                <b>Sub Role</b>
              </h4>

              {role.includes("merchant-role-create") ? (
                <div
                  className="d-flex align-items-center justify-content-around"
                  style={{ gap: "10px" }}
                >
                  <Button
                    title="Add Role"
                    color="primary"
                    onClick={() => setIsOpenModal(true)}
                  >
                    Add Role
                  </Button>
                </div>
              ) : null}
            </div>
          </CardHeader>
          <Table
            columns={columns}
            filterColumns={filterColumns}
            isLoading={isLoading}
            data={data?.data}
            isData={!!data?.data?.length}
            count={data?.total_item || 0}
            pagination={filter}
            isExpandable={false}
            handlePaginationChange={(pagination) => {
              setFilter({
                ...filter,
                ...pagination,
              });
            }}
            onColumnsChange={(columns) => {
              setFilterColumns(columns);
            }}
          >
            {data?.data?.map((val) => {
              return (
                <TableRow
                  columns={columns}
                  filterColumns={filterColumns}
                  isExpandable={false}
                  item={val}
                />
              );
            })}
          </Table>
        </Card>
      </div>
      <AddRoleModal
        isOpen={isOpenModal}
        onGet={() => setFilter({ ...filter })}
        onHide={() => setIsOpenModal(false)}
        merchantData={merchantData}
      />
      <DeleteModal
        title="Delete Role"
        content="Are you sure you want to delete user ?"
        isOpen={!!isDeleteOpenModal}
        onDoneClick={() => onDelete()}
        onCancelClick={() => {
          setIsDeleteOpenModal(null);
          setDeleteLoading(false);
        }}
        isButtonLoading={deleteLoading}
      />
    </>
  );
};

export default SubUser;
